import React, { useEffect } from "react";

function Item({ item }) {
    
 
  return (
    <div class="sec-item">
      <div class="sec-item__head d-flex">
        <div class="sec-head__text">
          <div class="head-text__subtitle">{item.category}</div>
          <div class="head-text__title">{item.name}</div>
        </div>
        <div class="sec-head__img">
          <img src={item.photo} alt="img" />
        </div>
      </div>
      <div class="sec-item__subtext">
        {item.description}
      </div>
      <div class="sec-item__footer sec-footer d-flex">
        <div class="sec-footer__first-item footer-first">
          <div class="footer-first__subs first-subs">
            <div class="first-subs__subtitle">Подписчики</div>
            <div class="footer-first__title">{item.followers}</div>
          </div>
          <div class="footer-f__subs first-subs">
            <div class="first-subs__subtitle">Доход</div>
            <div class="footer-first__title">{item.amount}$</div>
          </div>
        </div>
        <div class="sec-footer__second-item footer-second">
          <div class="footer__sec-price sec-price">Цена</div>
          <div class="sec-price__hm">{item.price}$</div>
          <div class="sec-price__more">
            <a href="#">Подробнее</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Item;
